module.exports = __webpack_public_path__ + "static/img/img-3-5.c11d14b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-5.png
// module id = +se8
// module chunks = 0